<template>
  <div class="trainer">
    <avatar-header :avatar="coach.avatar" />

    <weui-group :notitle="true">
      <weui-cell text="姓名" :tips="coach.name" />
      <weui-cell text="性别" :tips="formatGender(coach.gender)" />
    </weui-group>

    <weui-group>
      <weui-cell text="手机号码" :tips="coach.phone" />
    </weui-group>

    <weui-group>
      <weui-cell text="身高" :tips="`${coach.height} cm`" />
      <weui-cell text="体重" :tips="`${coach.weight} kg`" />
    </weui-group>

    <weui-button-area>
      <weui-button type="warn" @click="unbind">解除绑定</weui-button>
    </weui-button-area>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import weui from 'weui.js';

import { WeuiGroup, WeuiCell, WeuiButtonArea, WeuiButton } from '@/components/weui';
import AvatarHeader from '@/components/AvatarHeader';

import mixinFormatters from '@/mixins/formatters';
import { WECHAT_UNBIND } from '@/store/trainer/types';

const { mapState } = createNamespacedHelpers('coach');
const { mapActions: mapTrainerActions } = createNamespacedHelpers('trainer');

export default {
    computed: {
        ...mapState({
            coach: state => state.coach || {},
        }),
    },
    methods: {
        ...mapTrainerActions({
            wechatUnbind: WECHAT_UNBIND,
        }),
        unbind() {
            const vm = this;
            weui.confirm('确认解除会员的微信绑定吗？',
                () => {
                    vm.wechatUnbind()
                        .then(() => {
                            vm.$wechat.closeWindow();
                        });
                },
            );
        },
    },
    mixins: [
        mixinFormatters,
    ],
    components: {
        AvatarHeader,
        WeuiGroup,
        WeuiCell,
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/coach/Home.vue